export default String.raw`
.newsSection {
    width: 100%;
    padding: 0 9%;
    position: relative;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        a {
            display: flex;
            align-items: center;
            @include button;

            svg {
                margin-left: 4px;
                width: 16px;
                height: 16px;
            }
        }
    }

    &__arrows {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        width: 82%;
        aspect-ratio: 810 / 140;

        &-prev,
        &-next {
            position: absolute;
            z-index: 90;

            svg {
                width: 16px;
                height: 16px;
            }
        }

        &-prev {
            left: -24px;

            svg {
                rotate: 180deg;
            }
        }

        &-next {
            right: -24px;
        }
    }

    &__container {
        height: fit-content;

        &::before {
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
            width: 9%;
            height: 461px;
            background-color: $bgColor;
            z-index: 80;
        }

        &::after {
            display: block;
            position: absolute;
            bottom: 0;
            right: 0;
            content: "";
            width: calc(9% + 30px);
            height: 461px;
            background: linear-gradient(270deg, $bgColorAlphaStart 0%, $bgColorAlphaEnd 100%);
            z-index: 80;
            pointer-events: none;
        }
    }

    &__slide {
        width: calc(100% / 4.1);
    }
}
`